// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1_xSC","cls2":"ResearchInterestTags-cls2_kd_ ResearchInterestTags-cls1_xSC"};